<template>
  <v-data-table
    :headers="headers"
    :items="filteredItems"
    sort-desc
    calculate-widths
    class="settings-dt"
    dense
    fixed-header
    show-expand
    hide-default-footer
    :expanded="expanded"
    :item-key="'withdraw_limit_id'"
    :item-value="'withdraw_limit_id'"
    height="calc(100vh - 48px)"
    :loading="loading"
    :footer-props="{'items-per-page-options': [-1]}"
    :items-per-page="-1"
  >
    <template v-slot:body.prepend="{ item }">

      <tr v-if="Object.keys(filtersD).length > 0" class="report-filter-row grey lighten-3">
        <td></td>
        <td
          v-for="(header, index) in headers"
          :key="header.text"
        >
          <v-select
            v-if="filtersD.hasOwnProperty(header.value) && filtersD[header.value].type == 'select'"
            hide-details
            dense
            small
            multiple
            clearable
            persistent-hint
            single-line
            class="paymethod-filter-select mt-0"
            :items="filtersD[header.value].values || columnValueList(header.value) "
            :style="{width: (filtersD[header.value] || {width: false}).width}"
            v-model="filtersD[header.value].data"
          ></v-select>
          <v-autocomplete
            v-if="filtersD.hasOwnProperty(header.value) && filtersD[header.value].type == 'autocomplete'"
            hide-details
            dense
            small
            multiple
            clearable
            persistent-hint
            single-line
            class="paymethod-filter-select mt-0"
            :items="filtersD[header.value].values || columnValueList(header.value)"
            :style="{width: (filtersD[header.value] || {width: false}).width}"
            v-model="filtersD[header.value].data"
          ></v-autocomplete>
          <v-text-field
            dense
            class="paymethod-filter-textfield mt-0"
            v-if="filtersD.hasOwnProperty(header.value) && filtersD[header.value].type == 'text'"
            v-model="filtersD[header.value].data"
            :style="{width: (filtersD[header.value] || {width: false}).width}"
            hide-details
          ></v-text-field>
        </td>
      </tr>
    </template>

    <template v-slot:header.action="{ item }">

      <v-btn
        icon
        title="Refresh"
        class="px-0"
        @click="load"
        style="min-width: 36px"
      >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>

      <v-btn
        icon
        title="Add"
        class="px-0"
        @click="add"
        style="min-width: 36px"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </template>

    <template v-slot:expanded-item="{ headers, item }">
      <template v-for="(limit, country, index) in otherCountries(item.limits)">
        <tr class="expended-table-row" :key="`${Math.random()}-${country}-${index}`">
          <template v-if="!limit.edit">
            <td :class="header.value === 'action' ? 'text-start' : 'text-start'" v-for="header of headers">
              <template v-if="header.value === 'flattenCountries'">
                {{ country }}
              </template>

              <template v-else-if="header.value === 'action'">
                <div style="width: 145px;" class="mx-auto">
                  <v-btn
                    v-if="!item.newItem"
                    :title="limit.edit === false ? 'Edit' : 'Close'"
                    icon
                    @click="limit.edit = !limit.edit"
                  >
                    <v-icon v-if="limit.edit === false" small>mdi-pencil</v-icon>
                    <v-icon v-else small>mdi-close</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    title="Delete"
                    class="px-0"
                    style="min-width: 36px"
                    @click="save(item, true, country)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </template>

              <template v-else>
                {{ limit[header.value] }}
              </template>
            </td>
          </template>
        </tr>
        <update-row
          v-if="limit.edit"
          v-model="item"
          :is-limit="true"
          :country="country"
          :max-lvl-by-project="maxLvlByProject"
          @changeLimitCountry="(data) => changeLimitCountry(item, data)"
          @validationError="(error) => handleValidationError(item, error)"
        >
          <template v-slot:action="{ item }">
          <span style="white-space: nowrap; text-align: center">
            <v-btn
              v-if="!item.newItem"
              icon
              title="Save"
              class="px-0"
              style="min-width: 36px"
              @click="save(item)"
            >
                <v-icon>mdi-content-save-all</v-icon>
              </v-btn>
            <v-btn
              :key="country"
              icon
              :title="limit.edit === false ? 'Edit' : 'Close'"
              @click="closeUpdateRow(item, country)"
            >
              <v-icon v-if="limit.edit === false" small>mdi-pencil</v-icon>
              <v-icon v-else small>mdi-close</v-icon>
            </v-btn>
          </span>
          </template>
        </update-row>
      </template>

    </template>


    <template v-slot:item="{ item, headers, index, expand, isExpanded }">
      <tr v-if="!item.edit && !item.newItem">
        <td class="text-start" v-for="header of headers">
          <template v-if="header.value === 'data-table-expand'">
            <v-icon v-if="Object.keys(item.limits).length !== 0" @click="expand(!isExpanded)">{{ !isExpanded ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
          </template>
          <template v-if="header.value === 'entity_id'">
            {{ projectName(item.entity_id) }}
          </template>

          <template v-else-if="header.value === 'row_num'">
            <span class="row_num"></span>
          </template>
          <template v-else-if="header.value === 'flattenCountries'">
            <v-row class="ma-0" v-if="!isExpanded && showCountries(item.limits).length > 0">
              <b>
                {{ trim(showCountries(item.limits).slice(0, 3).join(', '), ', ') }}
                <template v-if="showCountries(item.limits).length > 3">
                  <span class="font-weight-regular">(+{{ showCountries(item.limits).length - 3 }})</span>
                </template>
              </b>
              <v-spacer />
              Default
            </v-row>
            <template v-else>
              Default
            </template>
          </template>

          <template v-else-if="header.value === 'action'">
            <v-row class="mx-auto" style="width: 145px">
              <v-btn
                icon
                :title="item.edit === false ? 'Edit' : 'Close'"
                @click="item.edit = !item.edit; if (!isExpanded) expand(true) "
              >
                <v-icon v-if="item.edit === false" small>mdi-pencil</v-icon>
                <v-icon v-else small>mdi-close</v-icon>
              </v-btn>

              <v-btn
                icon
                title="Delete"
                class="px-0"
                style="min-width: 36px"
                @click="save(item, true)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>

              <v-btn
                icon
                title="Add"
                class="px-0"
                @click="addLimit(item); expand(true)"
                style="min-width: 36px"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-row>
          </template>

          <template v-else>
            {{ item[header.value] }}
          </template>
        </td>
      </tr>

      <update-row
        v-if="item.newItem"
        :value="item"
        @input="(value) => updateItem(value, item)"
        :key="item.id"
        :max-lvl-by-project="maxLvlByProject"
      >
        <template v-slot:action="{ item }">
          <v-btn

            text
            title="Save"
            class="px-0"
            style="min-width: 36px"
            @click="save(item)"
          >
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
          <v-btn
            icon
            title="remove"
            class="px-0"
            @click="deleteNewItem(item)"
            style="min-width: 36px"
          >
            <v-icon>mdi-minus</v-icon>
          </v-btn>
          <v-btn
            icon
            title="Add"
            class="px-0"
            @click="addLimit(item); expand(true)"
            style="min-width: 36px"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
      </update-row>
      <update-row
        v-if="item.edit && !item.newItem"
        v-model="item"
        @validationError="(error) => handleValidationError(item, error)"
        :max-lvl-by-project="maxLvlByProject"
      >
        <template v-slot:action="{ item }">
          <span style="white-space: nowrap">
            <v-btn
              :disabled="item.edit === false"
              icon
              title="Save"
              class="px-0"
              style="min-width: 36px"
              @click="save(item)"
            >
              <v-icon>mdi-content-save-all
              </v-icon>
            </v-btn>

            <v-btn
              icon
              @click="resetItemToInit(item)"
              :title="item.edit === false ? 'Edit' : 'Close'"
            >
              <v-icon v-if="item.edit === false" small>mdi-pencil</v-icon>
              <v-icon v-else small>mdi-close</v-icon>
            </v-btn>

            <v-btn
              icon
              title="Add"
              class="px-0"
              @click="addLimit(item); expand(true)"
              style="min-width: 36px"
            >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
          </span>
        </template>
      </update-row>
    </template>

  </v-data-table>
</template>

<style>
  .settings-dt .expended-table-row {
    background-color: #f8f8f8;
  }

  .settings-dt .expended-table-row:hover {
    background-color: #FFFFFF;
  }

  .withdraw-countries-label {
    line-height: 6px;
    min-width: 20px;
  }

  .country-item {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .settings-dt tr:not(.report-filter-row) {
    counter-increment: row-num;
  }

  .settings-dt tr td:first-child .row_num::before {
    content: counter(row-num) ". ";
  }

</style>

<script>
  import { debounce, filter, find, get, isArray, map, sortBy, toString, uniq, trim, findIndex, indexOf, cloneDeep } from 'lodash'
  import { API } from '@/utils/api'
  import SelectCountries from '@/components/core/SelectCountries.vue'
  import LangCircle from '@/components/core/SelectLang/LangRow/LangCircle.vue'
  import SelectEditableCountries from '@/components/core/SelectEditableCountries.vue'

  export default {

    components: {
      SelectEditableCountries,
      LangCircle,
      SelectCountries,
      UpdateRow: () => import('@/components/settings/withdraw_limits/UpdateRow'),
    },

    data: () => ({
      loading: false,
      expanded: [],
      headers: [
        { text: 'Project', value: 'entity_id' },
        { text: 'Level', value: 'level' },
        { text: 'Currency', value: 'currency' },
        { text: 'Countries', value: 'flattenCountries' },
        { text: 'Min', value: 'min' },
        { text: 'Max', value: 'max' },
        { text: 'Per day', value: 'max_per_day' },
        { text: 'Per week', value: 'max_per_week' },
        { text: 'Per month', value: 'max_per_month' },
        { text: '', value: 'action', sortable: false },
      ],

      filtersD: {
        entity_id: { data: [], type: 'select' },
        flattenCountries: { data: [], type: 'select', values: [] },
        level: { data: [], type: 'autocomplete' },
      },
      items: [],
      validationErrors: {},
      maxLvlByProject: {},
    }),

    mounted () {
      this.load(true)
    },

    computed: {
      showCountries () {
        return (limits) => Object.keys(limits).filter(country => country !== 'default')
      },
      otherCountries () {
        return (limits) => Object.fromEntries(Object.entries(limits).filter(([ key ]) => key !== 'default'))
      },
      allUniqCountries () {
        return [ ...new Set(this.items?.flatMap?.(({ limits }) => Object.keys(limits))) ].filter((key) => key !== 'default')
      },
      selectedCountries () {
        return (item) => Object.entries(item?.limits ?? []).filter(([ key, value ]) => value.max > 0).map(([ key ]) => key) || []
      },
      filteredItems: function () {
        return this.items.filter(d => {
          return Object.keys(this.filtersD).every(f => {
            try {
              if (this.filtersD[f].data.length > 1 && typeof this.filtersD[f].data == 'string' && this.filtersD[f].data.toString().match(/^[><=!]{1,2}/)) {
                let filter = this.filtersD[f].data
                if (this.filtersD[f].data.toString().match(/^[><=!]{1,2}/)[0] == '=') filter = '=' + this.filtersD[f].data
                return eval((get(d, f) || '0').toString() + filter)
              }
            } catch (e) {
              return true
            }
            return this.filtersD[f].data.length < 1
              || ((this.filtersD[f].data.includes((get(d, f) || '')) && toString((get(d, f) || '')).length > 0)
                || (this.filtersD[f].data.includes(true) && ((get(d, f) || '').toString().toLowerCase()).length > 0)
                || (this.filtersD[f].data.includes(false) && ((get(d, f) || '').toString().toLowerCase()).length == 0)
                || (typeof get(d, f) != 'boolean' && ((get(d, f) || '').toString().toLowerCase()).indexOf(this.filtersD[f].data.toString().toLowerCase()) >= 0))
          })
        })
      },
    },

    watch: {
      allUniqCountries: {
        handler: debounce(function () {
          this.filtersD.flattenCountries.values = this.allUniqCountries
        }, 800),
        deep: true,
        immediate: true,
      },
    },

    methods: {
      updateItem({key, value}, item) {
        this.$set(item, key, value);
      },

      handleValidationError(item, error) {
        if (error.hasError) {
          this.$set(this.validationErrors, item.id, error.message)
        } else {
          this.$delete(this.validationErrors, item.id)
        }
      },
      closeUpdateRow (item, country, isNewItem=false) {
        const limit = item.limits[country]
        if (limit && limit.isNewLimit) {
          this.$delete(item.limits, country)
          this.$delete(this.validationErrors, item.id)
          return
        }

        const originalCountry = Object.keys(item.init.limits || {}).find(initCountry =>
          item.init.limits[initCountry] && item.init.limits[initCountry].currentCountry === country
        )

        if (originalCountry) {
          this.$delete(item.limits, country)
          const originalLimit = { ...item.init.limits[originalCountry] }
          delete originalLimit.currentCountry
          this.$set(item.limits, originalCountry, originalLimit)
          item.limits[originalCountry].edit = false
        }
        else if (item.init.limits && item.init.limits[country]) {
          const originalLimit = { ...item.init.limits[country] }
          delete originalLimit.currentCountry
          this.$set(item.limits, country, originalLimit)
          item.limits[country].edit = false
        }
      },

      resetItemToInit (item) {
        if (item.init) {
          item.currency = item.init.currency
          item.entity_id = item.init.entity_id
          item.level = item.init.level
          item.max = item.init.max
          item.max_per_day = item.init.max_per_day
          item.max_per_month = item.init.max_per_month
          item.max_per_week = item.init.max_per_week
          item.min = item.init.min

          if (item.init.limits && item.init.limits.default) {
            item.limits.default = structuredClone(item.init.limits.default)
          }
        }

        item.edit = !item.edit
      },
      changeLimitCountry (item, { current, previous }) {
        this.$set(item.limits, current, { ...item.limits[previous], edit: true })

        if(item.init) {
          this.$set(item.init.limits, previous, {...item.init.limits[previous], currentCountry: current})
        }
        this.$delete(item.limits, previous)

        this.$delete(this.validationErrors, item.id)
      },
      isArray, trim, cloneDeep,
      columnValueList (val) {
        if (val === 'level') {
          return this.levelColumnValue()
        }
        return uniq(sortBy(filter(this.items.map(d => val === 'entity_id' ? { text: this.projectName(get(d, val)), value: get(d, val) } : get(d, val)), (i) => i)))
      },

      // Separate handler to sort mixed (number | string) values as (string[], Ordered<number[], ASC>)
      levelColumnValue() {
        return uniq(this.items.map(item => item.level).sort((a, b) => {
          const aNum = Number(a)
          const bNum = Number(b)
          const isANum = !Number.isNaN(aNum)
          const isBNum = !Number.isNaN(bNum)

          if (isANum && isBNum) {
            return aNum < bNum ? -1 : 1
          }

          return -1
        }))
      },

      projectName (entity_id) {
        return find(this.$store.state.auth.entities, { entity_id })?.name || entity_id
      },
      addLimit (item) {
        this.$set(item.limits, '', { min: 10, max: 10000, max_per_day: 1000, max_per_month: 10000, max_per_week: 10000, edit: true, isNewLimit: true })
      },
      deleteNewItem(item) {
        const idx = this.items.findIndex(i => i === item);
        if (idx !== -1) {
          this.$delete(this.items, idx);
        }
      },
      add () {
        const newLimit = {
          newItem: true,
          edit: true,
          currency: null,
          level: null,
          entity_id: null,
          limits: {
            'default': {
              'max_per_day': 0,
              'max_per_week': 0,
              'max_per_month': 0,
              'max': 0,
              'min': 0
            },
          }
        }
        this.items = [cloneDeep(this.formatItem(newLimit)), ...this.items];
      },

      formatItem (item) {
        item.flattenCountries = Object.keys(item.limits)
        item.edit = false
        item.id = Math.random()

        for (const country in item.limits) {
          item.limits[country].edit = false
        }

        return structuredClone({ ...item, ...item.limits.default })
      },

      async save (item, to_delete = false, limitCountry = undefined) {

        if (!await this.$root.$confirm('Confirm', to_delete ? 'Delete limit' : 'Confirm saving changes')) {
          return
        }

        if (this.validationErrors[item.id]) {
          this.$notification.show = true
          this.$notification.message = this.validationErrors[item.id]
          this.$notification.type = 'error'
          return
        }

        if (item?.limits[''] && !to_delete) {
          this.$notification.show = true
          this.$notification.message = 'Can\'t save, in some limits country not selected'
          this.$notification.type = 'error'
          return
        }

        if (typeof limitCountry === 'string' && to_delete) {

          item.countryToDelete = limitCountry
        }
        if (to_delete) {
          item.to_delete = true
          item.init = { ...item }
        }

        this.loading = true

        return API.call('/settings/withdraw_limits/update.json', item).then(resp => {
          const updatedItem = resp.data

          if (item.newItem) item.newItem = false
          if (item.edit) item.edit = false

          if (to_delete && typeof limitCountry !== 'string') {
            this.items = this.items.filter(limit => limit.withdraw_limit_id !== updatedItem.withdraw_limit_id)
          }
          else if(typeof limitCountry === 'string' && to_delete) {
            const idx = findIndex(this.items, { withdraw_limit_id: item.withdraw_limit_id });
            if (idx !== -1) {
              this.$delete(this.items[idx].limits, limitCountry);
              const fcIdx = indexOf(this.items[idx].flattenCountries, limitCountry);
              if (fcIdx !== -1) {
                this.items[idx].flattenCountries.splice(fcIdx, 1);
              }
            }
          }
          else if (item.withdraw_limit_id) {
            const formattedItem = this.formatItem(updatedItem)
            for (const key in formattedItem) {
              this.$set(item, key, formattedItem[key])
            }
          } else {
            this.items.push(this.formatItem(updatedItem))
          }
        }).finally(() => {
          this.loading = false
          this.load()
        })
      },

      setLimits(limits) {
        this.items = map(limits, this.formatItem)
        this.items.forEach(item => {
          if (!item.init) {
            item.init = structuredClone(item)
          }
        })
      },

      load(withLvlMap = false) {
        this.loading = true

        Promise.all([
          API.call('/settings/withdraw_limits/list.json', {}),
          withLvlMap ? API.call('/settings/withdraw_limits/max_lvl_by_project.json', {}) : Promise.resolve()
        ])
          .then(r => {
            this.setLimits(r[0].data)

            if (withLvlMap) {
              this.maxLvlByProject = r[1].data
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    },

  }
</script>

